import SidebarActions from './SidebarActions.container';

export default SidebarActions;
